import { useCameraNamesLazyQuery } from '@kinetic-ui/data-layer';
import { DataSource, FormOption } from '@qfa/forms';
import { getNodes } from 'kineticUtils';
import { useCallback } from 'react';

export const useCameraNamesDataSource = (): DataSource<FormOption[]> => {
  const [getCameraNames] = useCameraNamesLazyQuery();

  const load = useCallback(async () => {
    const { data } = await getCameraNames();
    const signOptions = getNodes(data?.cameras).map((camera) => ({
      label: camera.name,
      value: camera.id,
    }));

    return signOptions as FormOption[];
  }, [getCameraNames]);

  return { load };
};
